/* eslint-disable no-mixed-spaces-and-tabs */
import AIHtmlTemplatesTable from '@/components/tables/AIHtmlTemplatesTable';
import { useFeatureFlagContext } from '@/context/featureFlagContext';
import React from 'react';

const AIHtmlTemplateTableTab = () => {
	const { getFeatureFlags } = useFeatureFlagContext();
	const viewAIHtmlTemplates = Boolean(getFeatureFlags('viewAIHtmlTemplates')?.active);

	return <>{viewAIHtmlTemplates && <AIHtmlTemplatesTable />}</>;
};
export default AIHtmlTemplateTableTab;
